import MobileIconUi from 'client/components/core/Sidebar/components/Settings/styles/ui/MobileIconUi'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'
import {
  ColorPickerStandaloneControl,
  ColorPickerStandaloneControlProps,
} from 'src/editor/shared/settings/controls/color-picker/color-picker-standalone-control'
import { twMerge } from 'tailwind-merge'

export interface ColorPickerControlProps
  extends ColorPickerStandaloneControlProps {
  label?: string
  labelClassName?: string
  singleColorMode?: boolean
}

export const ColorPickerControl = ({
  label = 'settings_styles.color.label',
  singleColorMode = false,
  labelClassName,
  ...props
}: ColorPickerControlProps) => {
  const { isMobile } = useDeviceModeContext()

  return (
    <OptionWrapper
      directionRow
      labelClassName={twMerge('text-textPrimary', labelClassName)}
      labelText={label}
      labelIcon={isMobile && !singleColorMode && <MobileIconUi />}
    >
      <ColorPickerStandaloneControl
        popoverProps={{
          ignoredEventTypes: [],
        }}
        {...props}
      />
    </OptionWrapper>
  )
}
